<template>
  <router-view />
</template>

<script setup lang="ts">
import { watch } from "vue";
import {
  useExperienceFormStore,
  saveToLocalStorage,
} from "./store/useExperienceFormStore";

const store = useExperienceFormStore();

// フォームの変更を監視してlocalStorageに保存
// （v-modelで直接formを編集するため、watchが必要）
watch(
  () => store.form,
  (newForm) => {
    saveToLocalStorage(newForm);
  },
  { deep: true },
);
</script>

<style lang="scss">
@use "@/assets/styles/experience-form.scss" as *;
</style>
